export default function(millis: number): string {
    return (Math.round(millis / 100) / 10).toFixed(1);
}
